module.exports = __webpack_public_path__ + "static/media/amex.69833284.svg";